export const apiConfig = {
    depService: `https://dep.penroseza.com`,
    unlockMoreService: `https://api.unlockmore.co.za`,
    campaignHubService: `https://campaign-hub.penroseza.com`,
    hyveService: 'https://hyve.thefanclash.co.za',
    key: `dkjbkjUIYIUbUBiuBKBPOJNP6786786KJBHKJYTDY9ijbo2131231sadfdKJBKJBKVTYCTXEDRXQLKNPKNQSKJBHKJBKJB5123765HJV6757HGVVHGV`
}
